import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
  searchValue: "",
  searchBy: [],
  page: 0,
  dataCount: 0,
  offset: 0,
  dataPerPage: 15,
  documentFiles: [],
  actionTrigger: false
};

export const DocumentsSlice = createSlice({
  name: "documents",
  initialState: initialState,
  reducers: {
    setSearchValue: (state, action) => {
      state.searchValue = { ...state.searchValue, ...action.payload };
    },
    setSearchBy: (state, action) => {
      state.searchBy = action.payload;
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setPageConfigData: (state, action) => {
      switch (action.payload.type) {
        case "SET_PAGE":
          state.page = action.payload.data;
          break;
        case "SET_DATA_COUNT":
          state.dataCount = action.payload.data;
          break;
        case "SET_IS_LOADING":
          state.isLoading = action.payload.data;
          break;
        case "SET_DATA_PER_PAGE":
          state.dataPerPage = action.payload.data;
          break;
        case "SET_OFFSET":
          state.offset = action.payload.data;
          break;
        default:
          break;
      }
    },
    setDocumentFiles: (state, action) => {
      state.documentFiles = action.payload
    },
    setActionTrigger: (state, action) => {
      state.actionTrigger = action.payload;
    },
  },
});
